import React, { useContext, useEffect, useState } from 'react'
import withSimpleApi, { WithSimpleApiProps } from '~/decorators/withSimpleApi'
import Editor from './show/Editor'
import Answers from './show/Answers'
import Info from './show/Info'
import MainContent from '../MainContent'
import Header from './show/Header'
import { WebsocketContext } from '~/service/WebsocketConn'
import { Channel } from 'phoenix'

type Star = {
  id: number
  color: string
}

type Template = {
  id: number
  name: string
  subject: string
  content: string
}

type Contact = {
  id: number
  type: number
  value: string
}

export type PhoneNumbers = { contacts: Contact[] }

type contact = {
  id: number
  name: string
  email: string
  version: number
}

type clientContact = {
  id: number
  type: number
  value: string
}

type category = {
  id: number
  name: string
  deleted: boolean
  readOnly: boolean
}

type subcategory = {
  id: number
  name: string
  deleted: boolean
}

export type AttachmentsType = {
  id: number
  size: number
  name: string
  icon: string
  type: string
}
type Cc = {
  id: number
  email: string
}

type InfolineCall = {
  id: number
  answered: boolean
  duration: number
  recorded: boolean
}

type Sms = {
  clientPhone: string
}

export type AnswerType = {
  id: number
  added: { date: Date }
  attachments: AttachmentsType[] | null
  chat: { created: Date } | null
  content: string | null
  delegated: boolean
  emailFrom: string | null
  infolineCall: InfolineCall | null
  newState: number | null
  normal: boolean
  private: boolean
  sms: Sms | null
  user: { id: number; name: string; main: boolean }
  userGuestEmail: string | null
  cc: Cc[]
  seconded: number[]
  changedState: boolean
  clientEmail: string | undefined
  editedData: { name: string; value: { old: string; new: string } } | null
}

export type TicketType = {
  id: number
  title: string
  number: number
  added: { date: Date }
  reportedBy: number
  client: {
    id: number
    name: string
    contacts: clientContact[]
    guards: number[]
  }
  emailFrom: string | null
  octopusEmailFrom: string
  closed: Date | null
  state: number
  unreaded: boolean
  urgent: boolean
  visited: boolean
  category: category | null
  subcategory: subcategory | null
  deadline: { date: Date } | null
  dateLastAnswer: { date: Date }
  firstAnswer: string
  answers: AnswerType[]
  withoutConsultantAnswer: boolean
  status: { name: string } | null
  assignedUsers: number[]
}

type TagType = {
  id: number
  name: string
}
type State = {
  ticket: TicketType
  answers: AnswerType[]
  tags: TagType[]
  responseTemplates: Template[]
  miniEel: boolean
  phoneNumbers: PhoneNumbers
  isDelegate: boolean
  primaryEmail: string
  reportType: { name: string; class: string } | null
  star: Star | null
  clientAvatar: string
  contacts: contact[]
}

export const TicketContext = React.createContext<State>({
  ticket: {} as TicketType,
  answers: [],
  tags: [],
  responseTemplates: [],
  miniEel: false,
  phoneNumbers: { contacts: [] },
  isDelegate: false,
  primaryEmail: '',
  reportType: null,
  star: null,
  clientAvatar: '',
  contacts: [],
})

const Show: React.FC<WithSimpleApiProps<State>> = ({ apiData }) => {
  const wsContext = useContext(WebsocketContext)
  const [type, setType] = useState<'public' | 'private'>('public')
  const [channel, setChannel] = useState<Channel | undefined>()
  const [ticketData, setTicketData] = useState(apiData)

  useEffect(() => {
    const channel = wsContext.socket.channel(
      'phone_ticket:' + window.c.campaignId + ':' + ticketData.ticket.id
    )
    setChannel(channel)

    channel.on('ticketAnswers', data => {
      setTicketData(items => ({
        ...items,
        answers: [data, ...items.answers],
      }))
    })

    channel.on('ticketDetails', data => {
      console.log('data', data)
      setTicketData(items => ({
        ...items,
        ticket: data,
      }))
    })

    channel.on('ticketState', data => {
      setTicketData(items => ({
        ...items,
        ticket: { ...items.ticket, state: data.state, closed: data.closed },
      }))
    })

    channel.join()
  }, [])

  return (
    <>
      {ticketData && (
        <TicketContext.Provider value={ticketData}>
          <div className="ticket-show-top">
            <Header />
          </div>
          <MainContent className="ticket-show-scroll">
            <div className="ticket-show">
              <div className="ticket-show-main">
                <Info />
                <Editor type={type} setType={setType} />
                <Answers />
              </div>
            </div>
          </MainContent>
        </TicketContext.Provider>
      )}
    </>
  )
}

const ShowWithApi = withSimpleApi(Show)

export default ShowWithApi
